(() => {
  'use strict';
  const config = document.querySelector('[data-rsp-launch-config]');
  if (!config) return;
  const preview = config.dataset.themeRole !== 'main';
  const theme = config.dataset.theme;
  const homePath = config.dataset.homePath || '/collections/custom-all';
  const rootPath = config.dataset.rootPath || '/';
  const url = value => {
    const target = new URL(value, location.origin);
    if (target.origin !== location.origin) return target;
    const isHome = target.pathname === rootPath || target.pathname === '/' ||
      /\/pages\/print-on-demand\/?$/.test(target.pathname) ||
      (target.pathname === homePath && target.searchParams.get('view') === 'rsp-storefront');
    if (isHome) target.pathname = homePath;
    if (/\/collections\/all\/?$/.test(target.pathname)) target.pathname = target.pathname.replace(/\/all\/?$/, '/custom-all');
    target.searchParams.delete('rsp_demo');
    if (/\/(products|collections)\//.test(target.pathname) || /\/(cart|search)\/?$/.test(target.pathname)) {
      target.searchParams.set('view', 'rsp-pod');
    }
    if (isHome) target.searchParams.set('view', 'rsp-storefront');
    if (preview) target.searchParams.set('preview_theme_id', theme);
    else target.searchParams.delete('preview_theme_id');
    if (target.searchParams.has('_f')) target.search = target.search.replace(/\+/g,'%20');
    return target;
  };
  window.RSPLaunch = { url };
  const within = (root, selector) => [
    ...(root.matches?.(selector) ? [root] : []),
    ...root.querySelectorAll(selector)
  ];
  const apply = root => {
    within(root, 'a[href]').forEach(link => {
      const raw = link.getAttribute('href');
      if (!raw || /^(#|mailto:|tel:|javascript:)/i.test(raw)) return;
      try {
        const target = new URL(raw, location.origin);
        if (target.origin !== location.origin || /\.(json|js|css|png|jpg|webp|svg|mp4|pdf)$/.test(target.pathname)) return;
        const resolved = url(raw).href;
        if (link.href !== resolved) link.href = resolved;
      } catch (_) {}
    });
    within(root, 'form[role="search"], facet-filters-form form').forEach(form => {
      [['view','rsp-pod'], ...(preview ? [['preview_theme_id',theme]] : [])].forEach(([name,value]) => {
        let input = form.querySelector('input[name="'+name+'"]');
        if (!input) { input = document.createElement('input'); input.type='hidden'; input.name=name; form.append(input); }
        input.value=value;
      });
    });
  };
  const init = () => {
    apply(document);
    const catalog = document.querySelector('#rsp-all-pod-products');
    if (catalog) {
      const grid = catalog.querySelector('#product-grid');
      const items = Array.from(grid.querySelectorAll('[data-rsp-catalog-item]'));
      const query = catalog.querySelector('[data-rsp-catalog-query]');
      const sort = catalog.querySelector('[data-rsp-catalog-sort]');
      const stock = catalog.querySelector('[data-rsp-catalog-stock]');
      const updateCatalog = () => {
        const term = query.value.trim().toLocaleLowerCase();
        let count = 0;
        const ordered = [...items].sort((a,b) => {
          if (sort.value === 'title') return a.dataset.title.localeCompare(b.dataset.title);
          if (sort.value === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
          if (sort.value === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
          return items.indexOf(a) - items.indexOf(b);
        });
        for (const item of ordered) {
          item.hidden = !item.dataset.title.toLocaleLowerCase().includes(term) || (stock.checked && item.dataset.available !== 'true');
          if (!item.hidden) count++;
          grid.append(item);
        }
        catalog.querySelector('[data-rsp-catalog-count]').textContent = `${count} of ${items.length} products`;
        catalog.querySelector('[data-rsp-catalog-empty]').hidden = count > 0;
      };
      query.addEventListener('input', updateCatalog);
      sort.addEventListener('change', updateCatalog);
      stock.addEventListener('change', updateCatalog);
      catalog.querySelector('[data-rsp-catalog-tools]').hidden = false;
      updateCatalog();
    }
    let queued = false;
    const pending = new Set();
    new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType === 1) pending.add(node);
        }
        const form = record.target.closest?.('form[role="search"], facet-filters-form form');
        if (form) pending.add(form);
      }
      if (queued || !pending.size) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        const roots = new Set(pending);
        pending.clear();
        roots.forEach(root => {
          if (!root.isConnected) return;
          for (let parent = root.parentElement; parent; parent = parent.parentElement) {
            if (roots.has(parent)) return;
          }
          apply(root);
        });
      });
    }).observe(document.body,{childList:true,subtree:true});
    window.addEventListener('click',event => {
      const link = event.target.closest('a[href]');
      if (link) {
        apply(link);
        const target = new URL(link.href, location.origin);
        // Use full navigation for POD menus and cart; preserve modified/new-tab clicks.
        const pageNavigation = /\/cart\/?$/.test(target.pathname) || link.closest('.rsp-pod-header-nav') || link.matches('.rsp-pod-header .header__heading-link');
        if (target.origin === location.origin && pageNavigation && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0 && link.target !== '_blank') {
          event.preventDefault(); event.stopImmediatePropagation(); location.assign(target.href);
        }
      }
    },true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
